import {Box, Container} from "@mui/material";
import styled from "@emotion/styled";
import {media} from "assets/css/media";

export const PoolWrapper = styled(Box)`
	width: 100%;
`;
export const PoolContainer = styled(Container)`
	background: var(--thirdColor);
	border-radius: 10px;
	padding-top: 20px;
	padding-bottom: 20px;

	h5 {
		font-family: var(--fontFamilyBase);
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: 130%;
		padding-bottom: 16px;
	}
`;
export const FilterWrapper = styled(Box)`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 12px 0px;
	width: 100%;
	border-top: 1px solid #c7c7cc;
	position: sticky;
	top: 0;
	background: var(--thirdColor);
	z-index: 9;

	@media (max-width: ${media.mobile}) {
		top: 40px;
	}

	form {
		background: var(--thirdColor);
		width: 100%;

		.MuiInputBase-input {
			color: #fff !important;
		}

		.MuiInputBase-formControl {
			&:after {
				border-color: var(--primaryColor);
			}
		}

		svg {
			path {
				fill: #c7c7cc !important;
			}
		}
	}
`;

export const ListHeader = styled(Box)`
	display: flex;
	gap: 7%;
	justify-content: center;
	padding: 16px 50px 16px 0;

	@media (max-width: ${media.mobile}) {
		padding: 16px 30px 16px 0;
	}

	> div {
		color: #fff;

		@media (max-width: ${media.mobile}) {
			font-size: 12px;
		}
	}
`;

export const ListWrapper = styled(Box)`
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
	justify-content: center;

	overflow: auto;
`;

export const PlayerPoolSlot = styled(Box)`
	position: relative;
	width: 100%;
	max-height: 88px;
	min-height: 86px;
	box-shadow: 0 0 2px rgba(28, 28, 30, 0.2);
	border-radius: 8px;
	display: flex;
	overflow: hidden;
	background: #fff;
	padding: 4px 50px 4px 4px;

	@media (max-width: ${media.mobile}) {
		margin-bottom: 6px;
		//max-height: 66px;
		//min-height: 66px;
	}
`;
export const PlayerPoolSlotImage = styled(Box)<{withPlayer: boolean}>`
	display: flex;
	flex: 1 1 88px;
	min-width: 88px;
	align-items: ${({withPlayer}) => (withPlayer ? "flex-start" : "flex-end")};
	justify-content: center;
	border-radius: 8px;
	overflow: hidden;
	cursor: pointer;

	&.europe {
		background: ${({withPlayer}) =>
			withPlayer ? "linear-gradient(180deg, #0076EB 0%, #003C82 100%)" : "transparent"};
	}

	&.usa {
		background: ${({withPlayer}) =>
			withPlayer ? "linear-gradient(180deg, #FB4D56 0%, #FF0019 100%)" : "transparent"};
	}

	img {
		display: block;
		width: 100%;
	}

	&:hover + .player-info .hover-underline {
		text-decoration: underline;
	}
`;
export const PlayerPoolSlotInfo = styled(Box)`
	display: flex;
	flex: 1 1 100%;
	padding: 0 5px 0 15px;
	justify-content: center;
	align-items: flex-start;
	flex-direction: column;
	gap: 5px;
	cursor: pointer;

	@media (max-width: ${media.mobile}) {
		padding: 0 5px 0 8px;
	}

	&:hover .hover-underline {
		text-decoration: underline;
	}
`;

export const PlayerSlotStats = styled(Box)`
	display: flex;
	flex: 1 1 100%;
	justify-content: center;
	align-items: center;
	color: var(--thirdColor);

	@media (max-width: ${media.mobile}) {
		flex: 1 1 120px;
	}
`;
export const StatsCell = styled(Box)`
	flex: 1;
	display: flex;
	justify-content: center;
`;

export const PlayerPoolInfo = styled(Box)`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 5px;
	color: var(--thirdColor);

	p {
		font-size: 14px;
	}

	span {
		font-size: 16px;
	}
`;
export const PlayerPoolSlotName = styled(Box)`
	font-family: var(--fontFamilyBase);
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 140%;
	color: var(--thirdColor);

	@media (max-width: ${media.mobile}) {
		font-size: 12px;
	}

	span {
		display: inline-flex;
		@media (max-width: ${media.mobile}) {
			display: flex;
		}
	}
`;
